var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 52,
    viewBox: "0 0 49 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627",
    transform: "translate(-598 -1031)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_596",
    "data-name": "Rectangle 596",
    width: 49,
    height: 52,
    transform: "translate(598 1031)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chatting",
    transform: "translate(604 1009.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M24.8,31.622H4.056A4.061,4.061,0,0,0,0,35.678v18.18a1.052,1.052,0,0,0,1.661.855l5.778-4.122a2.828,2.828,0,0,1,1.651-.528H21.8a4.061,4.061,0,0,0,4.056-4.056V32.673A1.051,1.051,0,0,0,24.8,31.622Zm-5.1,12.73H7.557a1.051,1.051,0,0,1,0-2.1H19.7a1.051,1.051,0,1,1,0,2.1Zm0-4.9H7.557a1.051,1.051,0,0,1,0-2.1H19.7a1.051,1.051,0,1,1,0,2.1Z",
    fill: "#0bd19f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M168.824,152.019V170.2a1.052,1.052,0,0,1-1.661.855l-5.778-4.122a2.828,2.828,0,0,0-1.651-.528H147.026a4.061,4.061,0,0,1-4.056-4.057v-1.992h11.781a6.165,6.165,0,0,0,6.158-6.158v-6.235h3.858A4.061,4.061,0,0,1,168.824,152.019Z",
    transform: "translate(-132.954 -108.189)",
    fill: "#0bd19f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatting);
export default __webpack_public_path__ + "static/media/chatting.d60c4fbc60ecaed327fb6690093e0c69.svg";
export { ForwardRef as ReactComponent };